const centsToCurrency = (value: string | number) => {
  const text = value.toString();
  if (text.includes('.')) return text;

  const padded = text.padStart(3, '0');
  return `${padded.slice(0, -2)}.${padded.slice(-2)}`;
};

type AmountItem = { amount: string | number };

export function formatAmount(value: string | number): string;
export function formatAmount<T extends AmountItem>(value: T[]): T[];
export function formatAmount<T>(value: T): T;
export function formatAmount(value: unknown) {
  if (!value) return value;

  if (Array.isArray(value)) {
    return value.map((item: AmountItem) => ({
      ...item,
      amount: centsToCurrency(item.amount),
    }));
  }

  return centsToCurrency(value as string | number);
}
